import React, { useEffect, useState } from 'react'

import { Button, InputNumber, message, Popconfirm, Select } from 'antd'

import { getApiTargetInfo } from 'core'
import {
  getUtilityNameMap,
  getUnitNameMap,
  getPermitActions,
  getEnvConfig,
} from 'core/selectors'

import { Label } from 'core/screen-util'
import { SppAcaClassAvgHeaders } from './ACAHeaders'
import {
  deleteclassAvgStat,
  getclassAvgStat,
  getUnitTypeInfo,
  postclassAvgStat,
} from './acaapi'
import { connect } from 'react-redux'
import CommonScreen from 'admin/component/CommonScreen'
import R from 'ramda'
import moment from 'moment'

const ACAStatictics = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  const [unitTypeList, setUnitTypelist] = useState([])
  useEffect(() => {
    getUnitTypeInfo(props.apiTargetInfo).fork(console.log, res => {
      setUnitTypelist(res.map(ut => ut.sppUnittype))
    })
  }, [props.apiTargetInfo])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns:
            '80px 100px 150px 350px 80px 130px 150px 100px 150px 130px 130px 150px 150px',
          gap: 5,
        }}
      >
        <Label>Year :</Label>
        <Select
          value={insertData.year}
          style={{ width: 120 }}
          onChange={val => {
            setInsertData({ ...insertData, year: val })
          }}
        >
          {R.range(-15, 10).map(idx => {
            const y = moment().year() - idx
            return (
              <Select.Option key={y} value={y}>
                {y}
              </Select.Option>
            )
          })}
        </Select>
        {/* <InputNumber
          value={insertData.year}
          onChange={val => setInsertData({ ...insertData, year: val })}
        /> */}
        <Label>SPP Unit Type :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.sppUnittype}
          onChange={value =>
            setInsertData({ ...insertData, sppUnittype: value })
          }
        >
          {unitTypeList.map(ut => (
            <Select.Option key={ut} value={ut}>
              {ut}
            </Select.Option>
          ))}
        </Select>

        <Label>Season :</Label>
        <Select
          // style={{ width: '150px' }}
          value={insertData.season}
          onChange={value => setInsertData({ ...insertData, season: value })}
        >
          <Select.Option value="Summer">Summer</Select.Option>
          <Select.Option value="Winter">Winter</Select.Option>
        </Select>

        <Label>Class Average EFORd :</Label>
        <InputNumber
          value={insertData.classAvgEford}
          onChange={val => setInsertData({ ...insertData, classAvgEford: val })}
          max={100}
        />
        <Label>Class Average EFOF :</Label>
        <InputNumber
          value={insertData.classAvgEfof}
          onChange={val => setInsertData({ ...insertData, classAvgEfof: val })}
          max={100}
        />

        <div style={{ gridColumnEnd: 'span 3' }}>
          <Button type="primary" onClick={() => onAdd(true)}>
            Add
          </Button>

          <Button
            type="primary"
            onClick={() => onAdd(false)}
            style={{ marginLeft: '20px' }}
          >
            Add & Hide
          </Button>
          <Button
            type="danger"
            onClick={onCancel}
            style={{ marginLeft: '20px' }}
          >
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const modifySaveDataBeforeSave = data => {
    const inValidData = data.find(({ classAvgEford, classAvgEfof }) => {
      if (!classAvgEford) {
        message.error(`Class Average EFORd is required.`)
        return true
      }
      if (
        classAvgEford &&
        !isNaN(classAvgEford) &&
        parseFloat(classAvgEford) > 100
      ) {
        message.error(
          `Class Average EFORd cannot be greater than 100.  (${classAvgEford})`
        )
        return true
      }

      if (
        classAvgEfof &&
        !isNaN(classAvgEfof) &&
        parseFloat(classAvgEfof) > 100
      ) {
        message.error(
          `Class Average EFOF cannot be greater than 100.  (${classAvgEfof})`
        )
        return true
      }
    })

    if (inValidData) {
      return false
    }

    return data
  }

  const extraCriteriaAfterButton = ({
    onRetrieve,
    isEditableAllowed,
    setSpinning,
    loading,
    data,
    apiTargetInfo,
    setError,
  }) => {
    if (!isEditableAllowed) return <div />
    return (
      <Popconfirm
        title="This action will delete all retrieved data. Do you want to continue?"
        okText="Yes"
        cancelText="No"
        onConfirm={() => {
          setSpinning(true)
          deleteclassAvgStat(apiTargetInfo)(data).fork(setError, _ => {
            setSpinning(false)
            message.success('Data removed successfully')
            onRetrieve()
          })
        }}
        // disabled={selected.selectedRows && selected.selectedRows.length <= 0}
        placement="topRight"
        // disabled
      >
        <Button
          loading={loading}
          icon="delete"
          style={{
            marginLeft: '10px',
            // color: '#FFFFFF',
            // backgroundColor: '#FF0000',
          }}
          type="danger"
          disabled={data.length <= 0}
        >
          Remove ALL
        </Button>
      </Popconfirm>
    )
  }

  const [year, setYear] = useState(moment().year())

  const screenCriteria = (s, p, u, onCriteriaChnage) => {
    return (
      <Select
        value={year}
        style={{ width: 120 }}
        onChange={val => {
          setYear(val)
          onCriteriaChnage({ year: val })
        }}
      >
        {R.range(-10, 10).map(idx => {
          const y = moment().year() - idx
          return (
            <Select.Option key={y} value={y}>
              {y}
            </Select.Option>
          )
        })}
      </Select>
    )
  }
  const withCriteria = _ => {
    return { year }
  }

  return (
    <CommonScreen
      withCriteria={withCriteria}
      screenCriteria={screenCriteria}
      extraCriteriaAfterButton={extraCriteriaAfterButton}
      modifySaveDataBeforeSave={modifySaveDataBeforeSave}
      title="SPP Class Average Statistics"
      header={SppAcaClassAvgHeaders}
      initialSortOptions={SppAcaClassAvgHeaders}
      saveTask={postclassAvgStat}
      retrieveTask={getclassAvgStat}
      deleteTask={deleteclassAvgStat}
      altBy={d => d.year}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      withImport
      importUrl="aepaca/classAvgStat/import"
      importData={{ importType: 'ACAP_CLASS_AVG_STAT' }}
      importSucessRetrieve
      defaultInsertData={{ year }}

      // widthOffset={550}
      // heightOffset={100}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  utilityNameMap: getUtilityNameMap(state),
  unitNameMap: getUnitNameMap(state),
  permitActions: getPermitActions(state),
  envConfig: getEnvConfig(state),
})

export default connect(mapStateToProps)(ACAStatictics)
